import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalProspectFinderCreateAccountDocument = gql`
  mutation SalesPortalProspectFinderCreateAccount(
    $supplierUUID: uuid!
    $name: String!
    $address: String!
    $metadata: RestaurantMetadataInput
    $creationSourceFeature: CreationSourceFeatures
  ) {
    supplierCreateRestaurant(
      supplier_id: $supplierUUID
      restaurant_name: $name
      restaurant_address: $address
      restaurant_metadata: $metadata
      creation_source_feature: $creationSourceFeature
    ) {
      business {
        name
        uuid
        restaurant_chats(where: { supplier_uuid: { _eq: $supplierUUID } }) {
          status
        }
      }
    }
  }
`;
export type SalesPortalProspectFinderCreateAccountMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalProspectFinderCreateAccountMutation,
    Types.SalesPortalProspectFinderCreateAccountMutationVariables
  >;
export function useSalesPortalProspectFinderCreateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalProspectFinderCreateAccountMutation,
    Types.SalesPortalProspectFinderCreateAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalProspectFinderCreateAccountMutation,
    Types.SalesPortalProspectFinderCreateAccountMutationVariables
  >(SalesPortalProspectFinderCreateAccountDocument, options);
}
export type SalesPortalProspectFinderCreateAccountMutationHookResult =
  ReturnType<typeof useSalesPortalProspectFinderCreateAccountMutation>;
export type SalesPortalProspectFinderCreateAccountMutationResult =
  Apollo.MutationResult<Types.SalesPortalProspectFinderCreateAccountMutation>;
export type SalesPortalProspectFinderCreateAccountMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalProspectFinderCreateAccountMutation,
    Types.SalesPortalProspectFinderCreateAccountMutationVariables
  >;
